import types from "../types/types";

export const candidates = (candidate, type = types.SET_CANDIDATES) => {
    return (dispatch) => {
        dispatch({
            type: type,
            payload: candidate
        })
    }
}